/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import * as mobx from 'mobx';
import { types, getEnv } from 'mobx-state-tree';

export default types
	.model('CardNotificationViewModel', {
		active: types.optional(types.boolean, false)
	})
	.volatile(()=>({
		isListOpen: false,
		_mobxDisposeEvents: []
	}))
	.actions((self) => ({

		afterCreate() {
			self._mobxDisposeEvents.push(
				mobx.reaction(() => {
					return self.active;
				}, () => {
					self.syncGlassBadge();
				}),
				mobx.reaction(() => {
					return self.isListOpen;
				}, () => {
					self.syncGlassBadge();
				})
			);
		},

		beforeDestroy() {
			// Remove the events.
			self._mobxDisposeEvents.forEach(dispose => dispose());
		},

		setListVisibility(state) {
			self.isListOpen = state;
		},

		setActive(state) {
			self.active = state;
		},

		syncGlassBadge() {
			const controller = getEnv(self).getNotificationController();
			if (controller) {
				if (self.active && !self.isListOpen) {
					controller.activate();
				} else {
					controller.deactivate();
				}
			}
		}
	}));



// WEBPACK FOOTER //
// ./src/js/glass/notification/CardNotificationViewModel.js